export const ADD_PRODUCTS_TO_WISHLIST = /* GraphQL */ `
    mutation addProductsToWishlist(
        $wishlistId: ID!
        $itemOptions: [WishlistItemInput!]!
    ) {
        addProductsToWishlist(
            wishlistId: $wishlistId
            wishlistItems: $itemOptions
        ) {
            wishlist {
                id
            }
            user_errors {
                code
                message
            }
        }
    }
`
